:host {
  display: block;
}
.coupon-container{
 display: flex;
 gap:4px;
 justify-content: space-between;
 background-color: white;
 padding: 2px;
 border-radius: 4px;
 height: 35px;
}
.coupon-input
{
width: 100%;
padding:0px 8px;
outline: none;
border: none;
}
.coupon-button{
 font-weight: 700;
 width: 59px;
 padding:0px 13px;
 display: flex;
 align-items: center;
justify-content: center;
 background-color: var(--mainColor);
 color: white;
 border-radius: 4px;
border: none;
}